import type { ColumnsType } from "antd/es/table";
import { Tag } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  AllUserFilesData,
  Counselor,
  User,
} from "../../../types/AllUserFileTypes";

export const AllUsersFilesColumns = (
  companyName: string,
  searchText: string
):

 ColumnsType<AllUserFilesData> => [
  {
  title: "Client ID",
  dataIndex: "user",
  key: "user",
  render: (value: User) => value?._id ?? "-",
  filteredValue: searchText ? [searchText] : null,
onFilter: (value, record) => {
  const search = String(value).toLowerCase();

  return (
    record.user?._id?.toLowerCase().includes(search) 
    // record.user?.counselor?.toLowerCase().includes(search)
  );
},

  

  
},

  {
    title: "Counselor",
    dataIndex: "counselor",
    key: "counselor",
    render: (value: Counselor) => value?.full_name ?? "-",
  },
  {
    title: "Session Number",
    dataIndex: "sessionNumber",
    key: "sessionNumber",
    render: (value?: number) => value ?? "-",
  },
  {
    title: "Last Taken",
    dataIndex: "lastTaken",
    key: "lastTaken",
    render: (date?: string) => {
      if (!date || !moment(date).isValid()) return "-";
      return moment(date).format("MMM DD, YYYY");
    },
  },
  {
    title: "Redflag Status",
    dataIndex: "redFlagStatus",
    key: "redFlagStatus",
    render: (status?: boolean) => {
      if (status === null || status === undefined) return "-";
      return status ? <Tag color="red">Yes</Tag> : <Tag>No</Tag>;
    },
  },
  {
    title: "Action",
    dataIndex: "user",
    key: "action",
    render: (name: User) => (
      <Link
        to={`/user-files-session-history/${companyName}/${encodeURIComponent(
          name._id
        )}`}
        className="table_pill_btn table_pill_btn--view"
      >
        View
      </Link>
    ),
  },
  
];

